/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Right_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Top right" |
*
* @param {Position_Top_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_right_aria_label = /** @type {((inputs?: Position_Top_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En haut a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вверху справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右上角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक तरह से ऊपर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto superior direito")
	return /** @type {LocalizedString} */ ("Top right")
});